{
	"dashboard": {
		"stats": {
			"skillCta": {
				"practice": "Practise"
			}
		},
		"skills": {
			"unlockSubtitle": "Unlock premium to practise",
			"startCta": "Practise",
			"proficiencySection": "Practise by proficiency level"
		},
		"recommendedTasks": {
			"startSessionAction": "Practise",
			"completedTestBody": "Review your results and personalised insights",
			"sectionalTestBody": "Take a focused test to practise your {{skills}} skills",
			"mixedSkillBody": "Practise question types like {{questionTypes}}, with a focus on where you need to improve"
		},
		"studyPack": {
			"freeContentBannerBody": "Practise selected {{skills}} items anytime. Upgrade to unlock the complete Study Pack."
		}
	},
	"skillDetail": {
		"diagnosticInsight": "In order to personalise your experience, start with a diagnostic quiz. The results from your diagnostic will be used to create your study plan."
	},
	"premium": {
		"unlockDescription": "Unlock personalised practice designed around your remaining study time.",
		"tip": "Your personalised focus, premium identifies what to practise next and adjusts your study plan as you improve."
	},
	"auth": {
		"createSessionLoader": {
			"analyzingMastery": "Analysing mastery"
		}
	},
	"onboarding": {
		"steps": {
			"examDate": {
				"daysAway": "That gives us {{value}} days. We will prioritise your weakest areas immediately."
			},
			"toeicLevelOverview": {
				"progression": {
					"practiceSessions": "Practise recommended sessions",
					"growToward": "Continue growing towards Proficient"
				}
			}
		}
	},
	"common": {
		"keepPracticing": "keep practising!"
	},
	"session": {
		"results": {
			"summary": {
				"proficiencyEstimateKeepPracticing": "Your estimated {{skill}} level is <bold>{{currentLevel}}</bold>. Keep practising before continuing to <bold>{{nextLevel}}</bold>."
			}
		},
		"timeOverrunBanner": {
			"message": "Time's up. On the real exam, anything after this would not be scored. You can keep practising."
		},
		"masteryLevels": {
			"infoSectionText": {
				"Writing": "The {{trademark}} Writing section measures your ability to write in English in an academic setting, and to present your ideas in a clear, well-organised way. You'll type your responses on a computer keyboard and it should take about 29 minutes to complete the Writing section."
			}
		},
		"explanation": {
			"skippedFeedbackNotice": "You skipped this question, so personalised feedback wasn't generated."
		},
		"finalizing": {
			"title": "Finalising your results"
		}
	},
	"questionTypes": {
		"descriptions": {
			"Retell Lecture": "A speaking task where the learner summarises a lecture or talk they listened to.",
			"Summarize Group Discussion": "A listening task where the learner summarises a multi-speaker discussion.",
			"Summarize Written Text": "A reading task where the learner summarises a passage in their own words."
		}
	},
	"report": {
		"pointsInfo": {
			"infoText": "You completed **{{numActivities}} {{activityLabel}}** to practise your {{skillsText}} {{skills}}. {{skillDetails}}. Overall, you earned **{{numPointsEarned}} out of {{numTotalPoints}} points**, suggesting a **{{compositeLevel}} proficiency** across {{thisText}} {{skills}}. {{compositeFeedback}}",
			"infoText.multiSkill": "You completed **{{itemCount}} {{itemLabel}}**, practising your **{{skills_text}}** skills. {{skill_details}} Overall, you earned **{{overall_score}} out of {{overall_total}} points**, suggesting a **{{overall_proficiency}}** proficiency across these skills. {{compositeFeedback}}"
		},
		"nextAction": {
			"fallback": {
				"title": "Keep practising"
			}
		},
		"sessionAnalysis": {
			"subtitle": "Personalised analysis and recommendations"
		}
	}
}
